// extracted by mini-css-extract-plugin
export default {"label":"dcc_conflictResolutionLabel-label","labelAdd":"dcc_conflictResolutionLabel-labelAdd","labelRemove":"dcc_conflictResolutionLabel-labelRemove"};